import React from "react";
import { Table, Text, Button, Stack } from "@mantine/core";
import { IconRefresh, IconAlertCircle } from "@tabler/icons-react";

interface ErrorStateProps {
  onRetry: () => void;
  error?: Error | null;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ onRetry, error }) => {
  return (
    <Table.Tr>
      <Table.Td colSpan={5}>
        <div className="no-clients-container">
          <div className="no-clients-content">
            <Stack align="center" gap="md">
              <IconAlertCircle size={48} color="var(--mantine-color-red-6)" />
              <Text size="lg" fw={500} c="red">
                Failed to load clients
              </Text>
              <Text size="sm" c="dimmed" ta="center">
                {error?.message ||
                  "An unexpected error occurred while fetching the client list."}
              </Text>
              <Text size="sm" c="dimmed" ta="center">
                Please check your connection and try again.
              </Text>
              <Button
                variant="filled"
                color="blue"
                leftSection={<IconRefresh />}
                size="md"
                onClick={onRetry}
              >
                Retry
              </Button>
            </Stack>
          </div>
        </div>
      </Table.Td>
    </Table.Tr>
  );
};
